import React, { createContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export const StatusERTDetailsContext = createContext({});
export const StatusERTDetailsContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const previousPage = location?.state?.pageName;
  const previousScreen = location?.state?.previousPage;
  const ertDetail = location?.state?.ertDetail;
  const goBack = () => {
    navigate(-1);
  };
  const providerValue = {
    goBack,
    previousPage,
    previousScreen,
    ertDetail,
  };
  return (
    <StatusERTDetailsContext.Provider value={providerValue}>
      {children}
    </StatusERTDetailsContext.Provider>
  );
};
